var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"fluidMainLessonInfo"}},[_c('div',{staticClass:"lesson-menu-header p-4 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.lesson.title[0]))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }